
import { $superAccountAxios } from "../../config/axios";
import {
  saveAccessTokenToLocalStorage,
  setImpersonation,
  setImpersonationBy,
} from "@/middleware/auth";
import localStore from "@/utils/localStore";

const state = {
  accountManagerProfile: {},
  accountManagerUsers: []
}
const getters = {
  getAccountManagerProfile: (state) => state.accountManagerProfile,
  getAccountManagerUsers: (state) => state.accountManagerUsers
}
const mutations = {
  SET_USER_DATA(state, userData) {
    state.accountManagerProfile = userData;
  },
  SET_ALL_ASSIGNED_USERS_OF_ACCOUNT_MANAGER(state, accountManagerUsers) {
    state.accountManagerUsers = accountManagerUsers;
  }
}
const actions = {
  async loginAsAccountManager(context) {
    const userId = localStore.getItem(`ACCOUNT_MANAGER-id`);
    const credentials = localStore.getItem(`ACCOUNT_MANAGER-${userId}`);

    if (credentials === undefined) {
      throw new Error("No Keys Available");
    }
    $superAccountAxios.defaults.headers.common.Authorization =
      credentials.access_token;
    await context.dispatch("fetchUserProfile");
    const userProfile = context.getters.getAccountManagerProfile;
    saveAccessTokenToLocalStorage(userProfile, credentials);
    context.commit("auth/SET_AUTH_STATUS", true, {
      root: true,
    });
  },

  fetchUserToken: async function(context, { userId, params }) {
    const response = await $superAccountAxios.get(
      `/account-manager/users/${userId}/signin`,
      {
        params,
      }
    );
    // saving accesstoken and refresh in the local storage
    const { user_details, access_token, refresh_token } = response.data;
    saveAccessTokenToLocalStorage(user_details, {
      access_token,
      refresh_token,
    });
    // saving the user data from the response
    context.commit("SET_USER_DATA", response.data.user_details, {
      root: true,
    });
    context.commit("auth/SET_AUTH_STATUS", true, {
      root: true,
    });
    return response.data;
  },

  LoginAsUser: async (context, userId) => {
    setImpersonation(true);
    setImpersonationBy("ACCOUNT_MANAGER");
    await context.dispatch("fetchUserToken", { userId, params: {} });
  },

  fetchUserProfile: async (context) => {
    const response = await $superAccountAxios.get("/profile");
    context.commit("SET_USER_DATA", response.data.user_details);
    const userDetails = response.data.profile;
    return userDetails;
  },
  fetchAllAssingedAccountUsers: async (context, params = {} ) => {
    try {
      const response = await $superAccountAxios.get(
        "account-manager/users", params
      );
      context.commit("SET_ALL_ASSIGNED_USERS_OF_ACCOUNT_MANAGER", response.data.users);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
  };
